document.addEventListener('DOMContentLoaded', function() {
	function closeJudgeMeModal() {
		const modal = document.querySelector('.jdgm-write-review-modal');
		if (modal && (modal.style.display === 'block' || modal.classList.contains('jdgm-open'))) {

			const closeBtn = modal.querySelector('.jdgm-write-review-modal__close-btn');
			if (closeBtn) {
				closeBtn.click();
				return;
			}
			modal.style.display = 'none';
			modal.classList.remove('jdgm-open');
			document.body.style.overflow = '';
		}
	}

	document.addEventListener('keydown', function(event) {
		if (event.key === 'Escape') {
			closeJudgeMeModal();
		}
	});

	document.addEventListener('click', function(event) {
		if (
			event.target.classList.contains('jdgm-write-review-modal') ||
			event.target.classList.contains('jdgm-write-review-modal__overlay')
		) {
			closeJudgeMeModal();
		}
	});
});